import { render, staticRenderFns } from "./BBYCAChangePrice.vue?vue&type=template&id=88af32c0&scoped=true"
import script from "./BBYCAChangePrice.vue?vue&type=script&lang=js"
export * from "./BBYCAChangePrice.vue?vue&type=script&lang=js"
import style0 from "./BBYCAChangePrice.vue?vue&type=style&index=0&id=88af32c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88af32c0",
  null
  
)

export default component.exports